export default "__VITE_ASSET__DEEnphzs__"